
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import VisionBanner from "../../../images/visionbanner.png";
import ProductPageBanner from '../../../images/Inner Page/JMF AMC Website Product Banner REV.jpg';
function NewProductsBanner() {
  return (
    <>
     <section className="banner-sc download-banner" aria-label="Partners Corner Banner">

                <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={ProductPageBanner}
                  alt="Products Page Banner"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">Products</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
    
    </>
  )
}

export default NewProductsBanner;